module.exports = __webpack_public_path__ + "img/olsidz.0d2fa1f2.jpg";